module.exports = __webpack_public_path__ + "static/media/in.d9924a24.svg";